































import { StoreActions, StoreMutations } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class Family extends Vue {
  get family() {
    return this.$store.state.family;
  }

  mounted() {
    this.$store.dispatch(StoreActions.GetFamily, this.$route.params.key)
  }

  destroyed() {
    this.$store.commit(StoreMutations.SetFamily, null)
  }

  edit() {
    this.$router.push(`/family/${this.$route.params.key}/edit`)
  }

  async approve(family: Family) {
    await this.$store.dispatch(StoreActions.ApproveSignup, family);
    this.$store.dispatch(StoreActions.GetFamily, this.$route.params.key)
  }
}

